const FundingSources = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'taxes', value: 80 },
    { type: 'state park fees', value: 8 },
    { type: 'development fees', value: 7 },
    { type: 'wastewater surcharge', value: 3 },
    { type: 'other', value: 2 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = '#funding-pie-chart';

  const data = [
    { type: 'Pollution Abatement Projects', value: 60 },
    { type: 'Special Projects', value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('margin-left', '8%')
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  const path = svg
    .datum(data)
    .selectAll('path')
    .data(pie)
    .enter()
    .append('path')
    .attr('fill', (d, i) => color(i))
    .attr('d', arc)
    .each(function (d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll('text')
    .data(pie)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${arc.centroid(d)})`)
    .attr('dy', '0.35em');

  text
    .append('tspan')
    .attr('x', '-0.4em')
    .attr('y', 0)
    .style('font-weight', 'bold')
    .style('font-size', '1.4rem')
    .style('text-align', 'center')
    .style('fill', '#FFF')
    .text(d => `${d.data.value}%`);

  const legend = d3.select(container).append('div').attr('class', 'funding-legend');

  const legendItems = d3.select('.funding-legend').selectAll('.funding-legend-item').data(data);

  legendItems.enter().append('div').attr('class', 'funding-legend-item').style('margin-top', '25px');

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-rect')
    .style('width', '40px')
    .style('height', '20px')
    .style('background-color', function (d, i) {
      return color(i);
    });

  d3.selectAll('.funding-legend-item')
    .append('div')
    .attr('class', 'funding-legend-text')
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      'Project Title':
        'East Shade Shelter Shoreline Stabilization Phase III',
      Total: '$906',
      'Authority Portion': '$906',
      'Proposed 2023 Budget': '$659',
      'Out-year Budget': '$196',
      'Funding Year(s)': '2021-2024',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - Reach 3',
      Total: '$2,567',
      'Authority Portion': '$640',
      'Proposed 2023 Budget': '$130',
      'Out-year Budget': '$510',
      'Funding Year(s)': '2023-2024',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - Reach 4',
      Total: '$2,720',
      'Authority Portion': '$680',
      'Proposed 2023 Budget': '$475',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2023',
    },
    {
      'Project Title': 'Cherry Creek - Reservoir to Lake View Drive Alternatives Analysis',
      Total: '$200',
      'Authority Portion': '$200',
      'Proposed 2023 Budget': '$200',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2023',
    },
    {
      'Project Title': 'Cherry Creek Stream Reclamation - at Dranfeldt Extension (Parker)',
      Total: '$6,010',
      'Authority Portion': '$400',
      'Proposed 2023 Budget': '$170',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2023',
    },
    {
      'Project Title': 'McMurdo Gulch Reclamation (Castle Rock)',
      Total: '$4,038',
      'Authority Portion': '$1,078',
      'Proposed 2023 Budget': '$907',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2022-2023',
    },
    {
      'Project Title': 'Happy Canyon Creek County Line to Cherry Creek  (SEMSWA)',
      Total: '$1,520',
      'Authority Portion': '$381',
      'Proposed 2023 Budget': '$88',
      'Out-year Budget': '$288',
      'Funding Year(s)': '2021-2026',
    },
    {
      'Project Title': 'Happy Canyon Creek Upstream of I-25 (MHFD)',
      Total: '$3,943',
      'Authority Portion': '$500',
      'Proposed 2023 Budget': '$250',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2022',
    },
    {
      'Project Title': 'Dove Creek U/S Pond D-1 to Chambers Rd (SEMSWA)',
      Total: '$650',
      'Authority Portion': '$163',
      'Proposed 2023 Budget': '$63',
      'Out-year Budget': '$75',
      'Funding Year(s)': '2022-2024',
    },
    {
      'Project Title': 'Dove Creek Otero to Chambers Rd. (SEMSWA)',
      Total: '$700',
      'Authority Portion': '$175',
      'Proposed 2023 Budget': '$75',
      'Out-year Budget': '$0',
      'Funding Year(s)': '2021-2023',
    },
    {
      'Project Title': 'Piney Creek Reach 1 to 2 (SEMSWA)',
      Total: '$2,350',
      'Authority Portion': '$515',
      'Proposed 2023 Budget': '$63',
      'Out-year Budget': '$414',
      'Funding Year(s)': '2022-2028',
    },
    {
      'Project Title': 'PRF Preservation, Acquisition, Lease of Land or Water',
      Total: '$550',
      'Authority Portion': '$550',
      'Proposed 2023 Budget': '$100',
      'Out-year Budget': '$450',
      'Funding Year(s)': '2023-2032',
    },
    {
      'Project Title': 'Total Capital Projects',
      Total: '$64,869',
      'Authority Portion': '$25,071',
      'Proposed 2023 Budget': '$3,180',
      'Out-year Budget': '$20,572',
      'Funding Year(s)': '',
    },
    {
      'Project Title': 'Routine',
      Total: '$595',
      'Authority Portion': '$595',
      'Proposed 2023 Budget': '$55',
      'Out-year Budget': '$540',
      'Funding Year(s)': '2023-2032',
    },
    {
      'Project Title': 'Operations',
      Total: '$844',
      'Authority Portion': '$844',
      'Proposed 2023 Budget': '$80',
      'Out-year Budget': '$764',
      'Funding Year(s)': '2023-2032',
    },
    {
      'Project Title': 'Restorative',
      Total: '$2,785',
      'Authority Portion': '$2,785',
      'Proposed 2023 Budget': '$130',
      'Out-year Budget': '$2,655',
      'Funding Year(s)': '2023-2032',
    },
    {
      'Project Title': 'Total Operations and Maintenance',
      Total: '$4,224',
      'Authority Portion': '$4,224',
      'Proposed 2023 Budget': '$265',
      'Out-year Budget': '$3,959',
      'Funding Year(s)': '2023-2032',
    },
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: '#cip-table',
    filterEnabled: false,
    tableHeaders: {
      'Project Title': 'Project Title',
      Total: 'Current Total Budget',
      'Authority Portion': 'Current Authority Portion',
      'Proposed 2023 Budget': 'Proposed 2023 Budget',
      'Out-year Budget': 'Out-year Budget',
      'Funding Year(s)': 'Funding Year(s)',
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
